import Swiper, {Scrollbar, Navigation} from 'swiper';
import 'swiper/swiper-bundle.css';

let swiper = new Swiper('.related-products-swiper', {
    slidesPerView: 1.75,
    spaceBetween: 30,
    centeredSlides: true,
    slideToClickedSlide: false,
    modules: [Scrollbar, Navigation],

    breakpoints: {
        768: {
            slidesPerView: 2,
            centeredSlides: false,
        },
        991: {
            slidesPerView: 3,
            centeredSlides: false,
        },

        1200: {
            slidesPerView: 4,
            centeredSlides: false,
        }
    },

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true
    }
});